import React from 'react'
import { Col, Grid, Row } from 'react-flexbox-grid'
import { Route, Switch } from 'react-router-dom'

import { QuarterlyRouteCostAnalysisViewIndex } from '../../views/ReportsQuarterlyRouteCostAnalysis'
import Header from './Header'
import './styles.scss'

export default class ReportsQuarterlyRouteCostAnalysisLayout extends React.PureComponent {
  render() {
    return (
      <Grid>
        <Row>
          <Col xs={12}>
            <Header />
          </Col>
        </Row>
        <Switch>
          <Route component={QuarterlyRouteCostAnalysisViewIndex} />
        </Switch>
      </Grid>
    )
  }
}
